// @flow
import React from "react";
import { logout } from "../../account/actions/userActions";
import Logo from "../../../images/logo.svg";

import {
  AccountCircle,
  GetApp,
  ExitToApp,
  Storage,
  TagFaces,
  Face,
  Business,
  People,
  Assignment,
  Forum,
  Event,
  Book,
  LibraryBooks,
  EventNote,
  Poll,
  SupervisorAccount,
  CardGiftcard,
  Ballot,
  HelpOutlined
} from "@material-ui/icons";
import { SvgIcon } from "@material-ui/core";

export const NavList = [
  {
    to: "/account/facesearch",
    text: "Facial Recognition",
    auth: ["online-user"],
    icon: <Face />,
    onClick: null
  },
  {
    to: "/account/people",
    text: "People",
    auth: ["online-user"],
    icon: <People />,
    onClick: null
  },
  {
    to: "/account/profile",
    text: "My Profile",
    auth: ["user"],
    icon: <AccountCircle />,
    onClick: null
  },
  {
    to: "/account/licence",
    text: "My Licences",
    auth: ["user"],
    icon: <CardGiftcard />,
    onClick: null
  },
  // {
  //   to: "/account/billing",
  //   text: "My Bills",
  //   auth: ["online-user-admin"],
  //   icon: <Ballot />,
  //   onClick: null
  // },
  {
    to: "/account/company",
    text: "My Company",
    auth: ["company_children_write", "company_children_read"],
    icon: <Business />,
    onClick: null
  },
  // {
  //   to: "/account/quote",
  //   text: "My Quotes",
  //   auth: ["billing"],
  //   icon: <Assignment />,
  //   onClick: null
  // },
  {
    to: "/account/project",
    text: "My Projects",
    auth: ["project"],
    icon: <Event />,
    onClick: null
  },
  {
    to: "",
    text: "Support",
    auth: ["user"],
    icon: <Forum />,
    onClick: (): * =>
      window.open("https://imagus.atlassian.net/servicedesk/customer/portal/1")
  },
  {
    to: "/account/software",
    text: "Latest Download",
    auth: ["company_children_write", "company_children_read", "imagus_admin"],
    icon: <GetApp />,
    onClick: null
  },
  {
    to: "",
    text: "Log Out",
    auth: ["user"],
    icon: <ExitToApp />,
    onClick: logout.bind(undefined, (): * => (window.location.href = "/logoff"))
  }
];

export const AdminList = [
  {
    to: "/admin/projects",
    text: "Projects",
    auth: ["imagus_admin"],
    icon: <Event />,
    onClick: null
  },
  {
    to: "/admin/resellers",
    text: "Confirm Authorised Resellers",
    auth: ["imagus_admin"],
    icon: <Business />,
    onClick: null
  },
  {
    to: "/admin/quotes",
    text: "Quotes",
    auth: ["imagus_admin"],
    icon: <Assignment />,
    onClick: null
  },
  {
    to: "/admin/companies",
    text: "Companies",
    auth: ["imagus_admin"],
    icon: <Business />,
    onClick: null
  },
  {
    to: "/admin/licences",
    text: "Licences",
    auth: ["imagus_admin"],
    icon: <GetApp />,
    onClick: null
  },
  {
    to: "/admin/facebases",
    text: "Facebases",
    auth: ["facebase-admin"],
    icon: <Poll />,
    onClick: null
  },
  {
    to: "/admin/users",
    text: "Users",
    auth: ["user-admin"],
    icon: <SupervisorAccount />,
    onClick: null
  },
  {
    to: "/admin/billings",
    text: "Billings",
    auth: ["imagus_admin"],
    icon: <Ballot />,
    onClick: null
  }
];

export const DocList = [
  {
    to: "/document/software",
    text: "Software",
    auth: ["user"],
    icon: (
      <img
        src={Logo}
        style={{
          width: "1em",
          height: "1em",
          display: "inline-block",
          fontSize: "30px",
          transition: "fill 200ms",
          userSelect: "none",
          flexShrink: 0
        }}
      />
    ),
    onClick: null
  },
  {
    to: "/document/api",
    text: "Api",
    auth: ["user"],
    icon: <Book />,
    onClick: null
  },
  {
    to: "/document/auth",
    text: "Authentication",
    auth: ["imagus_admin"],
    icon: <LibraryBooks />,
    onClick: null
  },
  {
    to: "/document/graphql",
    text: "GraphQl",
    auth: ["imagus_admin"],
    icon: <LibraryBooks />,
    onClick: null
  },
  {
    to: "/document/guides",
    text: "Help",
    auth: ["user"],
    icon: <HelpOutlined />,
    onClick: null
  }
];
export const LegalItem = {
  to: "",
  text: "Terms and Conditions",
  auth: ["user"],
  icon: <EventNote />,
  onClick: null
};
